import { RouteRecordRaw } from "vue-router";


const releaseRoute: RouteRecordRaw = {
  path: "/release",
  name: "Release",
  component: () => import("@/components/Releases/Express.vue"),
  children: [],
  redirect: `/release/express`,
};

releaseRoute.children?.push({
  name: 'express',
  path: `/release/express`,
  component: () => import("@/components/Releases/Express.vue"),
});
export default releaseRoute;
